export const getForm = (state) => state.form;
export const getQualifyingEventType = (state) => state.form.dependentApplicationForm.qualifyingEventType;
export const getBirthDate = (state) => state.form.dependentApplicationForm.values.bornAt;
export const getDependentType = (state) => state.form.dependentApplicationForm.values.dependentType;
export const getNewDependentPlans = (state) => state.newDependentPlans;
export const getNewDependentCost = (state) => state.newDependentCost;
